import { apiRequest } from '@/common/utils/request.common'
import { API_BASE_URL, HTTP_METHOD_GET } from '@/common/utils/request.const'

export const getLegacyConversions = async (credential) => {
  try {
    const requestOptions = {
      url: `${API_BASE_URL}/passes/v1/service/wavve/pc/legacy-conversions`,
      method: HTTP_METHOD_GET,
    }
    requestOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${credential}`,
      'wavve-credential': credential,
    }

    return await apiRequest(requestOptions)
  } catch (error) {
    return { data: undefined, error: error.response }
  }
}
